<template>
  <div class="p-5 pt-1">
    <pop-up
      :active.sync="popUp"
      @close="$router.push({ name: 'VesselLineUpList' })"
      @ok="$router.push({ name: 'VesselLineUpList' })"
    >
      You have successfully uploaded loading plan
    </pop-up>
    <p class="font-semibold text-3xl">
      Upload Loading Plan
    </p>
    <div class="flex flex-row p-5 my-3 bg-white rounded-2xl">
      <p class="self-center font-semibold text-xs lg:text-lg">
        Configuration Cell
      </p>
      <div class="flex flex-row gap-x-4 ml-auto">
        <vs-input
          v-model="cellStart"
          placeholder="Cell start"
        />
        <p class="self-center">
          -
        </p>
        <vs-input
          v-model="cellEnd"
          placeholder="Cell end"
        />
        <div class="flex items-center">
          <vs-button
            class="ml-auto"
            color="primary"
            @click="saveConfiguration"
          >
            Save Configuration
          </vs-button>
        </div>
        <div class="flex items-center">
          <vs-button
            type="border"
            color="primary"
            class="self-center font-semibold"
            style="min-width: 100px"
            @click="resetFilters"
          >
            Reset
          </vs-button>
        </div>
      </div>
    </div>
    <upload-file
      v-if="!isUploadDisabled"
      class="mt-6"
      :auto-preview="true"
      :is-browse-disabled="isUploadDisabled"
      @upload="uploadFile"
      @preview="previewTable"
      @remove="removeFile"
    />
    <div 
      v-if="!isEmpty(tableData)"
      class="mt-6"
    >
      <p class="self-center font-semibold text-xs lg:text-lg">
        Result
      </p>
    </div>
    <div 
      v-if="warningMessage"
      class="mt-2 warning flex flex-row items-center"
    >
      <img
        src="@/assets/shipo-icon-danger.svg" 
        alt="warning"
        class="w-7 h-7 mr-2"
      >
      <p
        v-html="warningMessage.replace(/\./g, '.<br>')"
      />
    </div>
    <div
      class="p-6 mt-6 bg-white rounded-2xl"
    >
      <vs-button
        v-if="!isEmpty(tableData)"
        class="button shadow-primary"
        color="primary"
        @click="submit"
      >
        Submit Loading Plan
      </vs-button>
      <data-table
        class="mt-6"
        :loading="isLoading"
        :table-header="tableHeaders"
        :table-data="tableData"
        :grouped-headers="groupHeader"
        :sort-by="sortBy"
        :sort-dir="sortDir"
        :body-height="isEmpty(tableData) ? '40vh' : '80vh'"
        @sort="sort"
      >
        <template #no="{ index }">
          <span>
            {{ index + 1 }}
          </span>
        </template>
        <template #product="{ row }">
          <select-with-search
            v-if="getProductOptions(row).length > 0"
            v-model="row.product"
            placeholder="Select Product"
            :options="getProductOptions(row)"
          />
          <span v-else>
            {{ row.product || '-' }}
          </span>
        </template>
        <template #product_id="{ row }">
          <span>
            {{ Array.isArray(row.product_id) 
              ? (row.product_id.length > 0 ? row.product_id.join(', ') : '-')
              : (row.product_id || '-') }}
          </span>
        </template>
        <template #trip_number="{ row }">
          <span>
            {{ row.trip_number || '-' }}
          </span>
        </template>
        <template #plan_quantity="{ row }">
          <span>
            {{ row.plan_quantity || '-' }}
          </span>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import PopUp from '@/components/popUp'
import SelectWithSearch from '@/components/selectWithSearch'
import UploadFile from '@/components/uploadFile'
import { PAGE_TITLE } from '@/fixtures/Constants'
import { isNumber,sortData } from '@/utils/salesPlanUtils'

export default {
  metaInfo: {
    title: `${PAGE_TITLE} Upload Loading Plan`
  },
  components: {
    UploadFile,
    DataTable,
    PopUp,
    SelectWithSearch
  },
  data(){
    return {
      isLoading: false,
      isSubmitDisabled: false,
      isUploadDisabled: false,
      cellStart: null,
      cellEnd: null,
      sortBy: '',
      sortDir: null,
      lastUploadedFile: null,
      tableHeaders: [
        { key: 'no', label: 'No', width: '50px' },
        { key: 'trip_number', label: 'Trip Number', width: '100px' },
        { key: 'tug', label: 'Tug Name', width: '150px' },
        { key: 'barge', label: 'Barge Name', width: '150px' },
        { key: 'product_id', label: 'Current Plan', width: '200px' },
        { key: 'product', label: 'Loading Plan', width: '200px' },
        { key: 'plan_quantity', label: 'Current Plan', width: '150px' },
        { key: 'barge_ton_actual', label: 'Loading Plan', width: '150px' },
        { key: 'blending_scheme_spec', label: 'Spesification', width: '150px' },
        { key: 'blending_scheme_ratio', label: 'Ratio', width: '150px' }
      ],
      groupHeader: [
        {
          title: 'Product ID',
          startColumn: 'product_id',
          endColumn: 'product',
          backgroundColor: '#F8F8F8'
        },
        {
          title: 'Quantity',
          startColumn: 'plan_quantity',
          endColumn: 'barge_ton_actual',
          backgroundColor: '#F8F8F8'
        },
        {
          title: 'Blending Scheme',
          startColumn: 'blending_scheme_spec',
          endColumn: 'blending_scheme_ratio',
          backgroundColor: '#F8F8F8'
        }
      ],
      tableData: [],
      popUp: false,
      warningMessage: null
    }
  },
  async mounted() {
    this.$store.dispatch('VesselLineUp/setVesselLineUpId', this.$route.params.id || this.vesselLineUpId)
    await this.fetchVLULoadingPlan()
    if (!this.loadingPlanVLU || this.loadingPlanVLU.length === 0) {
      this.isUploadDisabled = true
      this.showFailedNotification(this, 'No BLU Data available')
    }
  },
  computed: {
    ...mapGetters({
      vesselLineUpId: 'VesselLineUp/vesselLineUpId',
      loadingPlanPreview: 'VesselLineUp/loadingPlanPreview',
      loadingPlanVLU: 'VesselLineUp/loadingPlanVLU'
    })
  },
  methods: {
    async uploadFile(file) {
      if (this.cellStart && this.cellEnd) {
        this.cellStart = this.cellStart.toUpperCase()
        this.cellEnd = this.cellEnd.toUpperCase()
      }
      try {
        this.lastUploadedFile = file
        await this.$store.dispatch('VesselLineUp/uploadLoadingPlan', {
          loading_plan_file: file, 
          start: this.cellStart, 
          end: this.cellEnd,
          vlu_id: this.$route.params.id || this.vesselLineUpId
        })
        await this.previewTable()
      } catch (e) {
        this.$store.dispatch('UploadFile/reset')
        this.showFailedNotification(this, 'Failed to upload file, please try again')
      }
    },
    async fetchVLULoadingPlan() {
      try {
        this.isLoading = true
        await this.$store.dispatch('VesselLineUp/getLoadingPlanVLU', {
          id: this.$route.params.id || this.vesselLineUpId
        })
        this.isUploadDisabled = !this.loadingPlanVLU || this.loadingPlanVLU.length === 0
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.showFailedNotification(this, 'Failed to fetch loading plan, please try again')
      }
    },
    async previewTable() {
      this.isLoading = true
      this.tableData = this.loadingPlanPreview.data
      
      await this.fetchVLULoadingPlan()
      
      this.tableData = this.mergeDataAtSameIndex()
        
      this.warningMessage = this.loadingPlanPreview.message
      this.isLoading = false
    },
    mergeDataAtSameIndex() {
      if (!this.loadingPlanPreview.data || !this.loadingPlanVLU) {
        return []
      }

      if (this.loadingPlanVLU.length === 0) {
        return []
      }

      const maxRows = this.loadingPlanVLU.length
      const previewData = this.loadingPlanPreview.data.slice(0, maxRows)

      const mergedData = previewData.map((previewItem, index) => {
        const vluItem = this.loadingPlanVLU[index]
        
        if (vluItem) {
          return {
            ...previewItem,
            product_id: vluItem.product_id || previewItem.product_id,
            plan_quantity: vluItem.plan_quantity || previewItem.plan_quantity,
            product: previewItem.product || '',
            barge_ton_actual: previewItem.barge_ton_actual,
            blending_scheme_spec: previewItem.blending_scheme_spec,
            blending_scheme_ratio: previewItem.blending_scheme_ratio, 
            ...vluItem
          }
        }
        
        return {
          ...previewItem,
          product: previewItem.product || ''
        }
      })

      return mergedData
    },
    removeFile() {
      this.tableData = []
      this.isSubmitDisabled = false
      this.lastUploadedFile = null
      this.warningMessage = null
      this.isUploadDisabled = !this.loadingPlanVLU || this.loadingPlanVLU.length === 0
    },
    async saveConfiguration() {
      if (this.lastUploadedFile) {
        try {
          if (this.cellStart && this.cellEnd) {
            this.cellStart = this.cellStart.toUpperCase()
            this.cellEnd = this.cellEnd.toUpperCase()
          }
          await this.$store.dispatch('VesselLineUp/uploadLoadingPlan', {
            loading_plan_file: this.lastUploadedFile, 
            start: this.cellStart, 
            end: this.cellEnd,
            vlu_id: this.$route.params.id || this.vesselLineUpId
          })
          await this.previewTable()
        } catch (e) {
          this.showFailedNotification(this, 'Failed to re-process file with new configuration, please try again')
        }
      } else {
        if (!this.isEmpty(this.cellStart) && !this.isEmpty(this.cellEnd)) {
          this.showSuccessNotification(this, 'Configuration Saved Successfully')
        } else {
          this.showFailedNotification(this, 'Please fill in the configuration cell')
        }
        this.$store.dispatch('UploadFile/reset')
        this.tableData = []
        this.isSubmitDisabled = false
      }
    },
    async submit() {
      try {
        const form = {
          vessel_line_up_id: this.$route.params.id || this.vesselLineUpId,
          ...this.loadingPlanPreview,
          data: this.tableData.map(item=> ({...item, barge_line_up_id: item.id}))
        }
        await this.$store.dispatch('VesselLineUp/submitLoadingPlan', form)
        this.popUp = true
      } catch (e) {
        this.showFailedNotification(this, 'Failed to submit loading plan, please try again')
      }
    },
    formatCellData(key, data) {
      // Handle array data for product_id
      if (key === 'product_id' && Array.isArray(data)) {
        return data.join(', ')
      }
      
      return data || '-'
    },
    putOutOrFormatNumber(key, data) {
      if (data && isNumber(data)) {
        switch (key) {
          case 'barge_ton_plan':
          case 'barge_ton_actual':
          case 'cv_adb_plan':
          case 'cv_adb_actual':
          case 'cv_ar_plan':
          case 'cv_ar_actual':
            return this.loRound(data).toLocaleString('id-ID')
          default:
            return this.loRound(data, 2).toLocaleString('id-ID')
        }
      }
      return data || '-'
    },
    isNotNumber(key, data) {
      if (data && key !== 'product' && key !== 'tug_barge' && key !== 'blending_scheme') {
        return !isNumber(data)
      }
      return false
    },
    sort(sortBy, sortDir) {
      this.isLoading = true
      this.sortBy = sortBy
      this.sortDir = sortDir

      this.tableData = !sortDir
        ? this.loadingPlanPreview.data
        : sortData(this.loadingPlanPreview.data, sortBy, sortDir)
      this.isLoading = false
    },
    resetFilters() {
      this.cellStart = null
      this.cellEnd = null
      this.saveConfiguration()
    },
    getProductOptions(row) {
      // Get unique products from the uploaded file data
      if (!this.loadingPlanPreview.data) {
        return []
      }
      
      const allProducts = this.loadingPlanPreview.data.map(item => item.product).filter(Boolean)
      const uniqueProducts = [...new Set(allProducts)]
      
      return uniqueProducts.map(product => ({
        value: product,
        text: product
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.warning {
  @apply rounded-lg;
  @apply p-4;
  background-color: #f9b0494D;
  border: 1px solid #f9b049;

  p {
    color: #C47A11;
  }
}
</style>
